import * as React from 'react';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux'
import './PolicyDetails.css';
import { useState } from 'react';
import { DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showComingSoon } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';

const PolicyDetailsPersonalAccident = () => {
    const profileState = useSelector(state => state.profile);
    const cover = useSelector(state => state.profile.selectedPersonalCover)
    const dispatch = useDispatch();
    const [isInEdit, updateEditing] = useState(false);

    function editPolicyInfo() {
        //updateEditing(true);
        dispatch(showComingSoon());
    }

    function cancelEdit() {
        updateEditing(false);
    }

    function saveEdit() {
        updateEditing(false);
    }

    function submitAClaim() {
        dispatch(showComingSoon());
    }

    const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]

    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Personal accident" />
            }
            <div className="box">
                <div className="pt-3 d-lg-block d-none" id="PolicyDetails">
                    <div className="pl-3 pr-3 pt-3">
                        <div id="firstDiv">
                            <div className="row mb-lg-0">
                                <div className="col-7">
                                    <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                </div>
                                <div className="col-5 text-right">
                                    {!isInEdit &&
                                        <button className="btn btn-outline-red mb-3" onClick={editPolicyInfo} id="EditPolicy">Edit policy</button>
                                    }
                                    {isInEdit &&
                                        <div className="">
                                            <div className="mt-3 mb-3">
                                                <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                                <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row border-bottom py-2">
                                <div className="col-lg-7">
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div className="mb-3">
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                                <div className="col-lg-5 text-right">
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                </div>
                            </div>
                            <div className="row pt-3 pb-2">
                                <div className="col-lg-6">
                                    <p className="mb-2 Excess-amount-Title"><b>Excess amount</b></p>
                                    <p className="excessAmount mb-2">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                    <p className="insuredFor invisible">Insured for {profileState.currencySymbol}{cover.riskItems[0].insuredForValue}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-4 pt-3 d-lg-none d-block mb-5" id="PolicyDetailsMobile" style={{ display: "none" }}>
                    <div className="pl-3 pr-3">
                        <div id="firstDivMobile" className="">
                            <div className="row mb-lg-0">
                                <div className="col-12">
                                    <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div className="mb-3">
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    {!isInEdit &&
                                        <button className="btn btn-outline-red" onClick={editPolicyInfo} id="EditPolicy">Edit policy</button>
                                    }
                                    {isInEdit &&
                                        <div className="">
                                            <div className="mt-3 mb-3">
                                                <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                                <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row pb-3 border-bottom">
                                <div className="col-12">
                                    <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-12">
                                    <p className="mb-0"><b>Excess amount</b></p>
                                    <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                    <p className="insuredFor invisible">Insured for {profileState.currencySymbol}{cover.riskItems[0].insuredForValue}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyDetailsPersonalAccident);